import { blockCompanyBody } from '@planuze/admin-contracts';
import { toast } from '@planuze/ui';
import { useCompaniesContent } from '../../content/sections/companies.js';
import { useBlockCompany } from '../../hooks/use-companies.js';
import { companyErrorMessage } from './company-error.js';
import { CompanyReasonDialog } from './company-reason-dialog.js';

interface Props {
  readonly open: boolean;
  readonly onClose: () => void;
  readonly companyId: string;
  readonly companyName: string;
}

export function BlockCompanyModal({ open, onClose, companyId, companyName }: Props) {
  const copy = useCompaniesContent();
  const block = useBlockCompany(companyId);
  const confirm = (reason: string): void => {
    block.mutate(reason, {
      onSuccess: (outcome) => {
        if (outcome.status === 'already_blocked') {
          toast.info(copy.blockModal.alreadyBlocked(companyName));
        } else if (outcome.status === 'partial_success') {
          toast.warning(
            copy.blockModal.partialSuccess(companyName, outcome.failedSteps.join(', ')),
          );
        } else {
          toast.success(copy.blockModal.success(companyName));
        }
        onClose();
      },
      onError: (err) => {
        toast.error(companyErrorMessage(err, copy.errors));
      },
    });
  };
  return (
    <CompanyReasonDialog
      open={open}
      onClose={onClose}
      title={copy.blockModal.title(companyName)}
      description={copy.blockModal.description}
      confirmLabel={copy.blockModal.confirmLabel}
      destructive
      pending={block.isPending}
      validate={(reason) => blockCompanyBody.safeParse({ reason }).success}
      onConfirm={confirm}
    />
  );
}
